import React from 'react';

/**
 * @param {String} text the string to truncate with ...
 * @param {Number} maxLength the truncation length
 * @description Trims the text to a max length suffixed with ... if shorter than maxLength
 */
const Truncate = ({ text = '', maxLength = 300 }) => text.length > maxLength ?
    (
        <React.Fragment>
            {text.substring(0, maxLength)}
            <span>&hellip;</span>
        </React.Fragment>
    ) : text;

export default Truncate;
